import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { ConfirmationDialog as ConfirmDialog, ConfirmPopup } from 'az-platform-ui';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Page, Layout, ErrorHandler, ToastAlert, AlertMessage } from '../core';
import { PageHeader } from "./PageHeader";
import { HeaderTitle } from '../Constant';
import { userLoginLog, IsIpad} from '../Recoil-State';
import { authentication } from '../services';

const AppComponent = () => {
    const [isHeader, setIsHeader] = useRecoilState(IsIpad);
    // user login status update to server
    useRecoilValue(userLoginLog);

    useEffect(() => {
        let isSource = authentication.checkSourceFromUrl();
        if (isSource) {
            setIsHeader(true);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Layout>
            <ToastAlert />
            <ConfirmPopup />
            <ConfirmDialog />
            {/* {!isHeader && <Sidenavbar />} */}
            <Page>
                {!isHeader && <PageHeader title={HeaderTitle} />}
                <Page.Content isHeader ={isHeader}>
                    <AlertMessage/>
                    {/* Render Child Compoment  */}
                    <Outlet />
                </Page.Content>
            </Page>
        </Layout>
    )
}

export const Apps = ErrorHandler(AppComponent);